function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "1.1: ASBV Skeleton svg Copy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 224 0 224 24 0 24"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 369 0 369 24 0 24"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0 713 0 713 44 0 44"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-7",
  points: "0 0 713 0 713 56 0 56"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "1.1:-ASBV-Skeleton-svg-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.141717, 194.000000)",
  fill: "#FFFFFF",
  stroke: "#D6DCE3"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.5,
  y: 0.5,
  width: 712,
  height: 84
})), /*#__PURE__*/React.createElement("g", {
  id: "Loading-gradient-Copy",
  transform: "translate(0.000000, 109.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#D6DCE3",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Loading-gradient-Copy"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#D6DCE3",
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Loading-gradient-Copy",
  transform: "translate(0.000000, 141.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#D6DCE3",
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Loading-gradient-Copy",
  transform: "translate(0.000000, 32.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#D6DCE3",
  xlinkHref: "#path-7"
}))), /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 96.5,
  x2: 713,
  y2: 96.5,
  id: "Line-Copy-8",
  stroke: "#D6DCE3",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(16.000000, 209.000000)",
  fill: "#ECEFF3"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 304,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  x: 380,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 456,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  x: 532,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  x: 608,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  x: 228,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-8",
  x: 152,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-9",
  x: 76,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-10",
  x: 0,
  y: 0,
  width: 70,
  height: 24,
  rx: 12
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-11",
  points: "7 30 63 30 63 54 7 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-12",
  points: "83 30 139 30 139 54 83 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-13",
  points: "159 30 215 30 215 54 159 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-14",
  points: "235 30 291 30 291 54 235 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-15",
  points: "311 30 367 30 367 54 311 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-16",
  points: "387 30 443 30 443 54 387 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-17",
  points: "463 30 519 30 519 54 463 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-18",
  points: "539 30 595 30 595 54 539 54"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy-19",
  points: "615 30 671 30 671 54 615 54"
})));

var SvgAsbvLoadingSkeleton = function SvgAsbvLoadingSkeleton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "713px",
    height: "279px",
    viewBox: "0 0 713 279",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAsbvLoadingSkeleton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ASBV-loading-skeleton.737f2187.svg";
export { ForwardRef as ReactComponent };